<template>
<div class="hl-input-final" :class="getClasses">
  <label @click="focusInput" for=""><span class="required-red" v-if="required">*</span>{{label}}</label>
<input ref="input" :disabled="disabled" :class="getClasses" @animationstart="checkAnimation" :value="value" :type="type" @blur="blurHandler"  @keyup="keyup" @focus="focusedElement" :placeholder="placeholder" />
<div class="clear-input" @click.stop="setInputValue(null)" v-if="value && !isError && !forceInvalid"><svg width="14" height="14" viewBox="0 0 14 14" fill="rgb(115,115,115,1)" xmlns="http://www.w3.org/2000/svg">
  <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#737373"/>
</svg>
</div>
<div class="form-error">
  <svg width="20" v-if="isError || forceInvalid" height="20" viewBox="0 0 20 20" fill="rgba(241, 92, 34, 1)" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM10 0C4.47 0 0 4.5 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z" fill="#F15C22"/>
  </svg>
</div>
<div class="error-message" v-if="isError || forceInvalid">
  <span>{{errorText}}</span>
</div>

</div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    additionalClass:{
      type:String,
      default:''
    },
    validationType:{
      type:String,
      default:'required'
    },
    disabled:{
      type:Boolean,
      default:false,
    },
    value:{
      type:String,
      default:'',
    },
    forceInvalid:{
      type:Boolean,
      default:false,
    },
    setValue:{
      type:Function,
      default:() => {
        console.warn("setValue function not passed to HLInput component");
      },
    },
    errorText:{
      type: String,
      default:'This field is required'
    },
    required:{
      type:Boolean,
      default:false,
    },
    placeholder: {
      type: String,
      default:''
    },
    label: {
      type: String,
      default:null,
    },
    validateFn:{
      type:Function,
      default:() => {
        return true;
      }
    },
    formValidationFn:{
      type:Function,
      default:() => {
        return true;
      }
    },
  },
  name: "HLInput",
  data(){
    return{
      focused: false,
      currentValue:null,
      interactedWith:false,
    }
  },
  methods: {
    checkAnimation(e) {
      if(e.animationName === 'clearInput'){
        this.setValue(null);
      }
      if(e.animationName === 'autofill'){
        this.focused = true;
      }
    },
    isValid(){
        if(this.validationType === 'required'){
          if(this.value && this.value.length){
            return true;
          }
          return false;
        }
        return true;
    },


    focusedElement() {
      this.focused = true;
    },
    focusInput(){
      //this.$refs.input.focus();
    },
    keyup(e){
      this.interactedWith = true;
            this.setInputValue(e.target.value);
            //this.setValue(this.$refs.input.value);
            if(this.formValidationFn){
                //this.formValidationFn();
            }
    },
    blurHandler(e){
      this.focused = false;
      this.interactedWith = true;
      //this.setInputValue(this.$refs.input.value);
      if(this.formValidationFn){
        this.formValidationFn();
      }
      this.error = !this.isValid();
    },
    setInputValue(value){
      //if value is null
      if(value === null){
        this.setValue('');
        this.currentValue = '';
        return;
      }
      if(value && !value.length){
        return;
      }

      this.setValue(value);
    }
  },
  computed:{
    getClasses(){
      let base = {focused: this.focused }
      if(this.additionalClass) base[this.additionalClass] = true;
      if(this.disabled) base['disabled'] = true;
      if(this.value || this.currentValue){
        base['filled'] = true;
      }
      return base;
    },
    isError(){
      if(!this.interactedWith) return false;
      return !this.isValid();
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/variables/default";
@import "../assets/scss/variables/media";
$topoffset:  18px;
.hl-input-final{
  position:relative;
  display:flex;
  flex-direction: row;
  align-items: center;
  width:auto;
  flex-wrap:nowrap;
  padding-bottom:5px;
  padding-top:5px;
  margin-bottom:5px;
  .form-error {
    padding-top:0;
  }
  svg{
    margin-left:-28px;
    margin-top:-12px;
  }
  &.taller.in-modal{
    &.fourtyheight{
      input{
        height:40px;
      }
    }
    &.bs{
      input{
        box-sizing:content-box;
      }
    }
    margin-bottom:20px;
    label{
      top:22px;
    }
  }


  label{
    position:absolute;
    color:#888888;
    transition:all 0.2s ease-in-out;
    font-family: HL-Whitney-Book, sans-serif;
    top: $topoffset;
    left:10px;
    font-weight: normal;
    pointer-events: none;
    font-size:14px;
  }
  &.focused,&.filled{
    label{
      position:absolute;
      top:-10px;
      left:10px;
      color:#222222;
      font-size: 12px;
      font-family: HL-Whitney-Bold, sans-serif;
      @media(max-width: $media-mobile){
        top:-12px;
      }
    }
    &.fourtyheight{
      label{
        top:5px;
      }
    }
  }


  input{
    padding: 16px 6px 16px 12px;
    background-color: white;
    border: 1px solid #EEEEEE;
    min-width:250px;
    &:focus{
    }
    &.disabled{
      background-color: #737373;
      appearance: none;
      color:black;
      &:hover{
        cursor: not-allowed;
      }
    }
    &.full,&.wide{
      width:100%;
    }
  }
  .error-message{
    position:absolute;
    bottom: 11px;
    left: 10px;
    color: $hlRed;

    span{
      font-size: 11px;
      font-family: 'HL-Whitney-Book',"Whitney A","Whitney B",sans-serif;
    }

  }
  .required-red{
    color: $hlRed;
  }

}



</style>
